import { render, staticRenderFns } from "./I2FormAddressInput.vue?vue&type=template&id=2b109b14&scoped=true"
import script from "./I2FormAddressInput.vue?vue&type=script&lang=js"
export * from "./I2FormAddressInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b109b14",
  null
  
)

export default component.exports